import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { PasswordStrengthBarModule } from "ng2-password-strength-bar";
import { ReCaptchaModule } from "angular2-recaptcha/angular2-recaptcha";

import { MaterialAppModule } from "../ngmaterial.module";

import { ForcePasswordChangeComponent } from "./force-password-change/force-password-change.component";
import { LoginFormComponent } from "./login-form/login-form.component";
import {
	ForgotPasswordComponent,
	ForgotPasswordChangeComponent,
	ForgotPasswordEmailPendingComponent,
	ForgotPasswordFormComponent
} from "./login-form/forgot-password";
import { RegistrationComponent } from "./registration.component";
import { RegistrationService } from "./registration-service/registration.service";
import { CommonModule } from "../common/common.module";
import { InvalidCodeComponent } from "./invalid-code/invalid-code.component";

export const ROUTES: Route[] = [
	{
		path: "forgotPassword",
		component: ForgotPasswordComponent,
	},
	{
		path: "login",
		component: RegistrationComponent,
		children: [
			{
				path: "",
				component: LoginFormComponent,
				data: { initial: "login" },
			}, {
				path: "login",
				component: LoginFormComponent,
				data: { initial: "login" },
			}, {
				path: "loginVerify",
				component: LoginFormComponent,
				data: { initial: "login", verify: "verify" },
			}, {
				path: "invalidCode",
				component: InvalidCodeComponent,
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		PasswordStrengthBarModule,
		ReCaptchaModule,
		MaterialAppModule
	],
	declarations: [
		ForcePasswordChangeComponent,
		LoginFormComponent,
		ForgotPasswordComponent,
		ForgotPasswordChangeComponent,
		ForgotPasswordEmailPendingComponent,
		ForgotPasswordFormComponent,
		RegistrationComponent,
		InvalidCodeComponent
	],
	entryComponents: [
		ForcePasswordChangeComponent
	],
	providers: [
		RegistrationService
	],
	exports: [
		ForcePasswordChangeComponent,
		LoginFormComponent,
		ForgotPasswordComponent,
		ForgotPasswordChangeComponent,
		ForgotPasswordEmailPendingComponent,
		ForgotPasswordFormComponent,
		RegistrationComponent,
	]
})
export class LoginModule { }
